const authConstants = {
	LOGIN_SUCCESS: 'LOGIN_SUCCESS',
	LOGIN_REQUEST: 'LOGIN_REQUEST',
	LOGIN_FAILURE: 'LOGIN_FAILURE',
	UNAUTHENTICATED: 'UNAUTHENTICATED',
}

export default authConstants;
